import { render, staticRenderFns } from "./Chart.pug?vue&type=template&id=9f50a84e&lang=pug&external"
import script from "./Chart.js?vue&type=script&lang=js&external"
export * from "./Chart.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports